import React, { useEffect, useState } from "react";
import Layout from "../../../../components/layouts/Layout";
import UserDetailHeader from "../../../../components/user-detail/UserDetailHeader";
import DataTable from "react-data-table-component";
// import "react-toastify/dist/ReactToastify.css";
import ProgressComponent from "../../../../components/general/ProgressComponent";
import { GET_USERS_LOG_SUMMARY_REPORT } from "../../../../env";
import Dropdown from 'react-bootstrap/Dropdown';
import * as XLSX from "xlsx";
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Line } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';

import {
    getRecords,
    isSuccess,
    filterColumns,
    filterRowsByProperty,
    displayEnumProperty,
    // toastErrorMessages,
    catchAsync,
    // toastSuccessMessages,
    addActivityLog,
} from "../../../../helper/helper";
import moment from "moment";
import Input from "../../../../components/forms-fields/Input";
import CustomSelectStaffMember from "../../../../components/forms-fields/CustomSelectMultipleStaffMembers";
import CustomSelectServiceUsers from "../../../../components/forms-fields/CustomSelectServiceUsers";

function UsersLogs() {

    const [filteredRows, setFilteredRows] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedStaffRequesterIds, setSelectedStaffRequesterIds] = useState([]);
    const [selectedServiceUserIds, setSelectedServiceUserIds] = useState([]);
    const [startDate, setStartDate] = useState(moment().subtract(1, "day").valueOf());
    const [endDate, setEndDate] = useState(moment().valueOf());

    const [apiQuery, setApiQuery] = useState({
        sortproperty: "createdAt",
        sortorder: -1,
        offset: 0,
        // limit: 100,
        startDate: startDate,
        endDate: endDate,
        userIds: [],
    });

    // ✅ Merge user IDs when any selection changes
    useEffect(() => {
        const mergedUserIds = [
            ...selectedStaffRequesterIds,
            ...selectedServiceUserIds,
        ];

        setApiQuery((prev) => ({
            ...prev,
            userIds: mergedUserIds,
            startDate: startDate ? moment(startDate).valueOf() : prev.startDate,
            endDate: endDate ? moment(endDate).valueOf() : prev.endDate,
        }));
    }, [selectedStaffRequesterIds, selectedServiceUserIds, startDate, endDate]);

    const handleUserSelect = (selectedIds) => {
        // console.log("Staff Requester IDs:", selectedIds);
        setSelectedStaffRequesterIds(selectedIds || []);
    };

    const handleServiceUserSelect = (selectedIds) => {
        // console.log("Service User IDs:", selectedIds);
        setSelectedServiceUserIds(selectedIds || []);
    };

    // ✅ For debugging or triggering API calls
    useEffect(() => {
        // console.log("Updated apiQuery:", apiQuery);
        fetchAllRecords();
    }, [apiQuery]);

    const processFetchRecords = (method, data) => {
        if (data?.status !== isSuccess) {
            // toastErrorMessages(toast?.error, data?.message, "", 1000, 1000);
        } else if (method === "get" && data?.status === isSuccess) {

            const staffMembers = data?.data
            // console.log("🚀 ~ processFetchRecords ~ staffMembers:", staffMembers)
            const filteredRows = filterRowsByProperty(
                staffMembers,
                (row) => row?.user?.name
            );
            // setUserData(filteredRows);
            setFilteredRows(filteredRows);
            setIsLoading(false);
        }
    };

    const fetchAllRecords = catchAsync(async (req, res) => {
        const response = await getRecords(GET_USERS_LOG_SUMMARY_REPORT, apiQuery);

        processFetchRecords("get", response);
    });

    useEffect(() => {
        fetchAllRecords();
    }, []);

    const columns = [
        {
            name: "#",
            selector: (row, index) => (
                <span >
                    {index + 1}
                </span>
            ),
            width: "5%",
            center: true,
        },
        {
            name: "Name",
            selector: (row) => {
                return (
                    <div
                        className="usersNameInfo py-2"
                    >
                        <span className="userInfo">
                            <span className="nameBlock">{`${row?.user?.name && row?.user?.name}`}{" "}{`${row?.lastName !== null && row?.lastName !== undefined ? row?.lastName : ""}`}</span>
                            <small className="nameBlock">
                                Job Title:
                                {
                                    row?.user?.role === "superadmin" ? "Super Admin" : row?.userDetails?.jobTitle
                                }
                            </small>
                            <small className="nameBlock"> Email:<a
                                href={`mailto:${row?.user?.email}`}
                                className="blackColor"

                            >
                                {row?.user?.email}
                            </a></small>

                        </span>
                    </div>
                );
            },
        },
        {
            name: "Action",
            selector: (row) => {
                return (
                    <>
                        <div
                            className="usersNameInfo py-2"
                        >
                            <span className="userInfo">
                                <span className="nameBlock">{row?.action} {row?.module ? " - " + row?.module : null}</span>
                                <small className="nameBlock"> Date & Time:{moment(row?.createdAt).format("DD-MM-YYYY HH:mm")}</small>
                            </span>
                        </div>
                    </>
                );
            },
            wrap: true,
        },
        {
            name: "Device Management",
            selector: (row) => {
                return (
                    <>
                        <div
                            className="usersNameInfo py-2"
                        >
                            <span className="userInfo">
                                <span className="nameBlock">Device Name: {row?.deviceName}</span>
                                <span className="nameBlock">Device Id: {row?.deviceId}</span>
                                <span className="nameBlock">IP Address:{row?.ipAddress}</span>
                            </span>
                        </div>
                    </>
                );
            },
            wrap: true,
        },

    ];

    const filteredColumns = filterColumns(columns, (column) => column !== null);


    // Export Data

    const styles = StyleSheet.create({
        pages: {
            padding: "10px",
        },
        sectionTitle: {
            fontSize: "16px",
            fontWeight: "black",
            marginBottom: "5px",
            textAlign: "center",
            padding: "10px",
            backgroundColor: "#f0f0f0"
        },
        sectionSubTitle: {
            fontSize: "14px",
            fontWeight: "black",
            marginBottom: "5px",
            textAlign: "center",
            padding: "10px",
            backgroundColor: "#f0f0f0"
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1,
        },
        tableHead: {
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundColor: "#f0f0f0",
            padding: "10px 10px",
            marginBottom: "5px",
            fontSize: "10px",
            fontWeight: "bold",
            wordWrap: "break-word",
        },
        tabBody: {
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "10px 10px",
            borderBottom: "1px solid #ccc",
            fontSize: "10px",
            wordWrap: "break-word",
        },
        wordwrap: {
            flexBasis: "50%",
            wordWrap: "break-word",
        },
    });

    const MyDocument = (start) => (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.pages}>
                <View>
                    <Text style={styles.sectionTitle}>Users Logs Reports</Text>
                    <View style={styles.tableHead}>
                        <Text style={{ width: "25%" }}>Name</Text>
                        <Text style={{ width: "25%" }}>Action</Text>
                        <Text style={{ width: "50%" }}>Device Management</Text>

                    </View>
                    {filteredRows.map((row, index) => (
                        <View key={index} style={styles.tabBody}>
                            <Text style={{ width: "25%" }}>
                                {`${row?.user?.name && row?.user?.name}`}{" "}{`${row?.lastName !== null && row?.lastName !== undefined ? row?.lastName : ""}\n`}
                                Job Title: {`${row?.user?.role === "superadmin" ? "Super Admin" : (row?.userDetails?.jobTitle || "")}\n`}


                                {`${row?.user?.email && 'Email: ' + row?.user?.email + `\n`}`}
                            </Text>
                            <Text style={{ width: "25%" }}>
                                {`${row?.action || ""}\nDate & Time: ${row?.createdAt ? moment(row.createdAt).format("DD-MM-YYYY HH:mm") : ""}`}

                            </Text>
                            <Text style={{ width: "50%" }}>
                                {`Device Name: ${row?.deviceName || ""}\nDevice Id: ${row?.deviceId}\nIP Address: ${row?.ipAddress}`}
                            </Text>
                        </View>
                    ))}
                </View>
            </Page>
        </Document >
    );

    const ExportButton = ({ data, data2, patientName, removeMoreColumns }) => {
        const handleExport = () => {
            // Preprocess data to format dates before exporting
            const formattedData = data.map(
                ({
                    ...item
                }) => {
                    const userName = item?.user?.name
                    const jobTitle = item?.userDetails?.jobTitle
                    const email = item?.user?.email
                    const actionDateTime = moment(item?.createdAt).format("DD-MM-YYYY HH:mm") || "";
                    removeMoreColumns.forEach((column) => {
                        delete item[column];
                    });



                    // const actionDate = moment(item?.createdAt).format("DD/MM/YYYY") || "";


                    return {
                        ...item,
                        userName: userName,
                        jobTitle: jobTitle,
                        email: email,
                        actionDateTime: actionDateTime,

                    };
                }
            );

            const formattedData2 = [{ "Users Logs Reports": patientName }];

            const fileType =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";
            const fileName = patientName;

            // Convert dataWithTitles array to worksheet
            let ws = XLSX.utils.json_to_sheet(formattedData2);

            // Add second data set to existing worksheet
            const ws2 = XLSX.utils.json_to_sheet(formattedData, {
                header: Object.keys(formattedData[0]),
                skipHeader: true,
            });

            XLSX.utils.sheet_add_json(ws, formattedData, {
                header: Object.keys(formattedData[0]),
                skipHeader: false,
                origin: -1,
            });

            // Create workbook
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

            // Write workbook to array buffer
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

            // Convert array buffer to Blob
            const blob = new Blob([excelBuffer], { type: fileType });

            // Create download link and trigger download
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName + fileExtension;
            a.click();
            // Add activity log AFTER download
            addActivityLog({
                message: `Download in Excell`,
                module: "Users Logs Reports",
            });
        };

        return <span onClick={handleExport}>Export as xlsx</span>;
    };



    return (
        <>
            <Layout pageTitleText="Users Logs Reports">
                <header className="headerContainerSearchAction">
                    <div className="actionButtons">
                        <div className="gap-1">
                            <a className="btn btn-sm btn-primary" href="/reports">
                                Back to Reports
                            </a>
                            <>
                                {
                                    filteredRows.length > 0 && (
                                        <Dropdown>
                                            <Dropdown.Toggle variant="outline-success" size="sm" id="dropdown-basic">
                                                Export Data
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="exportDataList">
                                                <>
                                                    <span className="">
                                                        <PDFDownloadLink document={<MyDocument columns={columns} data={filteredColumns} />} fileName={"Users Logs Reports"}>
                                                            {({ loading }) =>
                                                                loading ? (
                                                                    "..."
                                                                ) : (
                                                                    <span
                                                                        onClick={() =>
                                                                            addActivityLog({
                                                                                message: "Download in PDF",
                                                                                module: "Users Logs Reports",
                                                                            })
                                                                        }
                                                                    >
                                                                        Export as PDF
                                                                    </span>
                                                                )
                                                            }
                                                        </PDFDownloadLink>
                                                    </span>
                                                    <span className="">
                                                        <ExportButton data={filteredRows} patientName={"Users Logs Reports"} removeMoreColumns={["_id", "user", "userDetails", "userModelName", "createdAt", "updatedAt", "__v"]} />
                                                    </span>
                                                </>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )
                                }
                            </>
                        </div>
                    </div>
                    <div className="searchFilters">
                        <div className="searchFilterItem form-group userSelection">
                            <CustomSelectStaffMember
                                name="staffRequester"
                                onSelect={handleUserSelect}
                                filterBy=""
                                label="Staff Requester"
                                isMulti={true}
                            />
                        </div>

                        <div className="searchFilterItem form-group userSelection">
                            <CustomSelectServiceUsers
                                name="serviceUserId"
                                onSelect={handleServiceUserSelect}
                                filterBy=""
                                label="Service User"
                                isMulti={true}
                            />
                        </div>

                        <div className="searchFilterItem dateSelection">
                            <Input
                                type="date"
                                datePicker={true}
                                name="startDate"
                                selected={startDate ? moment(startDate).toDate() : null}
                                dateFormat="dd/MM/yyyy"
                                onChange={(date) => setStartDate(date)}
                                labelText="Start Date"
                                placeholderText="Start Date"
                                showYearDropdown={true}
                            />
                        </div>

                        <div className="searchFilterItem dateSelection">
                            <Input
                                type="date"
                                datePicker={true}
                                name="endDate"
                                selected={endDate ? moment(endDate).toDate() : null}
                                dateFormat="dd/MM/yyyy"
                                onChange={(date) => setEndDate(date)}
                                labelText="End Date"
                                placeholderText="End Date"
                                showYearDropdown={true}
                            />
                        </div>
                    </div>
                </header>
                {/*                <PDFViewer style={{ width: "100%", height: "300px" }}>
                    <MyDocument />
                </PDFViewer> */}
                <div className="mainContent noCursorPointer" style={{ minHeight: "500px" }}>
                    <div className="dataTableWrapper staffRecordsGroupsTable">
                        <DataTable
                            className="maxWidthTable"
                            columns={filteredColumns}
                            data={filteredRows}
                            fixedHeader
                            fixedHeaderScrollHeight="520px"
                            highlightOnHover
                            responsive={true}
                            subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
                            progressPending={isLoading}
                            progressComponent={<ProgressComponent />}
                        />
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default UsersLogs;
